export default __webpack_public_path__ + "images/86fc051e9ed5a472f3cb25323a050df2-snow_sports.webp";